module.exports = __webpack_public_path__ + "static/media/kitchen6.8f532bcf.png";